import React from 'react';
import styles from './StudyFormField.scss';
import classnames from 'classnames';
import { Button, BUTTON } from 'components/common/Button/Button';
const { COLOR, BGCOLOR, OUTCOLOR } = BUTTON;
import { PageTitle } from 'components/common/Study/PageComponents';

export const StudyFormField = ({className, id, label, isRequired, children}) => (
    <div className={classnames(styles.studyFormField, className)} data-cy="StudyFormField">
        <label htmlFor={id}>
            {label}{ isRequired && <span className={styles.required}> *Required</span>}
        </label>
        {children}
    </div>
);

export const PrimaryStepAction = (props) => {
    const {
        exitButtonText,
        saveButtonText,
        onClickExit,
        onClickSave,
        saveButtonDisabled,
        exitButtonDisabled,
    } = props;
    return <div className={classnames(styles.primaryStepAction, props.className)}>
        <Button
            onClick={onClickExit}
            bgcolor={BGCOLOR.WHITE}
            color={COLOR.BLACK}
            disabled={exitButtonDisabled}
            outline={OUTCOLOR.LIGHTGREY}
            data-cy="StudyFormField-onClickExit"
        >
            {exitButtonText}
        </Button>
        <Button
            onClick={onClickSave}
            bgcolor={BGCOLOR.ORANGE}
            color={COLOR.WHITE}
            disabled={saveButtonDisabled}
            data-cy="StudyFormField-onClickSave"
        >
            {saveButtonText}
        </Button>
    </div>;
};

export const StudyStepTitle = ({ children }) => (
    <PageTitle className={styles.studyStepTitle} data-cy="StudyFormField-children">
        {children}
    </PageTitle>
);

export const StudyStepSubTitle = ({ children }) => (
    <h2 className={styles.studyStepSubTitle} data-cy="StudyFormField-h2">
        {children}
    </h2>
);

export const StudyStepInfoContainer = (props) => (
    <div className={styles.studyStepInfoContainer} data-cy="StudyFormField-props">
        {props.children}
    </div>
);
